import { Fragment, useEffect, useRef, useState } from "react";
import {
  addDepletionDetails,
  addWorkHistoryDetails,
  editDepletionDetails,
  editWorkHistoryDetails,
  getDepletionDetails,
  getPropertyDetails,
} from "../../homepurchase.service";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SuccessToastConfig } from "app/utils/ToastConstants";
import { ErrorToastConfig } from "app/utils/ToastConstants";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Loading } from "app/components";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { formatDate } from "app/utils/utility.service";
import { getSessionUserInformation } from "app/utils/utility.service";
import { InputNumber } from "primereact/inputnumber";
import { NumericFormat } from "react-number-format";

const initialState = {
  name: "",
  value: "",
  amount: "",
  percentage: "",
  startDate: ""
};

const AddDepletion = ({
  addDepletionModal,
  handleAddDepletionModal,
  title,
  values,
  setValues,
}) => {
  const toast = useRef();
  const options = [{ name: "Yes" }, { name: "No" }];
  const [selectedId, setSelectedId] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isPermit, setIsPermit] = useState(false);
  const [searchParams] = useSearchParams();
  const sessionValues = getSessionUserInformation();
  const clientId = searchParams.get("clientid");
  const [isLoading, setIsLoading] = useState(false);
  const [depletionDetails, setDepletionDetails] = useState([]);
  const [label, setLabel] = useState("");
  const onHide = () => {
    setFormSubmitted(false);
    setValues(initialState);
    handleAddDepletionModal(false);
  };
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const navigate = useNavigate();
  const showSuccess = (message) => {
    toast.current.show(SuccessToastConfig(message));
  };
  const showError = (message) => {
    toast.current.show(ErrorToastConfig(message ? message : "Error"));
  };
  const validateInput = () => {
    if (
      !values.percentage ||
      !values.startDate ||
      values.startDate < values.purchaseDate
    ) {
      return false;
    }
    return true;
  };
  useEffect(() => {
    let label = title.indexOf("Add") > -1 ? "Add" : "Save";
    setLabel(label);

    const fetchDepletionDetails = async () => {
      const userId =
        clientId && clientId !== "null" ? clientId : sessionValues.id;
      let list = await getDepletionDetails(userId);
      if (list) {
        setIsLoading(false);
        if (list) {
          list.map((li, index) => (li.srNo = index + 1));
        }
        setDepletionDetails(list);
        
      }
    };

    fetchDepletionDetails();
  }, [addDepletionModal]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
   
  };
  // Function to handle input changes and calculations
  const handleChange = (name, value) => {
    
    const newValues = { ...values, [name]: value };
    
    // Convert to numbers safely
    const curr_val = parseFloat(newValues.value) || 0;
    const depPercent = parseFloat(newValues.percentage) || 0;

    // Perform calculations
    newValues.amount =  curr_val * (depPercent / 100)
    
    // Set new state only if values have changed
    setValues(newValues);
  };
  const handleInputChangeNumber = (name, e) => {
    let value = e.target.value.replace(/[$,]/g, '');

    setValues({
      ...values,
      [name]: parseFloat(value),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    if (!validateInput()) {
      return false;
    }
    setValues({
      ...values,
      accountCategoryId: values.id,
    });
    let details;
    setIsLoading(true);
    let msg = "";
    if (title.indexOf("Add") !== -1) {
      details = await addDepletionDetails(values);
      msg = "Depletion details added successfully";
    } else {

      details = await editDepletionDetails(values, values?.id);
      msg = "Depletion details updated successfully";
    }
    if (details) {
      showSuccess(msg);

      setTimeout(() => {
        onHide();
      }, 1000);
    } else {
      showError(details?.message);
    }
    setIsLoading(false);
  };
  const renderFooter = () => {
    return (
      <div>
        <div className="grid">
          <div className="col-3"></div>
          <div
            className={`${
              isDesktopOrLaptop ? "col-7" : "col-12 text-align-center"
            }`}
          >
            <Button
              label="Cancel"
              className="p-button-raised p-button-lg"
              onClick={() => onHide()}
            />
            <Button
              type="submit"
              label={label}
              className={`p-button-raised p-button-warning p-button-lg  ${
                isDesktopOrLaptop ? "" : "ml-4"
              }`}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Dialog
      header={title}
      visible={addDepletionModal}
      onHide={() => onHide()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "35vw" }}
      footer={renderFooter()}
      className="AnnualExpenseModal"
      position="top"
      closeOnEscape={false}
      draggable={false}
    >
      <div className="center-align">
        {isLoading && <Loading />}
        <Toast ref={toast} className="ToastMessage" />
        <div className="AddPropertyForm">
          <form method="post" onSubmit={handleSubmit}>
          <div className={`mt-4 ${isDesktopOrLaptop ? "text-right" : ""}`}>
            <div className="grid">
              {/* Asset */}
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-4">Asset Name</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field mt-1">
                  <div className="p-inputgroup">
                    <InputText
                      className=""
                      autoComplete="off"
                      required={true}
                      name="name"
                      value={values?.name}
                      disabled={true}
                    />
                  </div>
                  
                </div>
              </div>

              {/* Current Value*/}
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-5">Current Value</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field mt-1" style={{width:"103%"}}>
                  <div className="p-inputgroup">
                    <InputNumber
                      className="vw-inputtext-with-border pl-0"
                      autoComplete="off"
                      required={true}
                      name="value"
                      disabled={true}
                      value={values?.value}
                      prefix="$ "
                    />
                  </div>
                  
                </div>
              </div>

              
              {/* Percentage */}
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-4">Percentage</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field mt-1">
                  <div className="p-inputgroup">
                    <span className="p-float-label">
                      <NumericFormat
                        className="input-field"
                        style={{"width":"100%"}}
                        thousandSeparator=","
                        autoComplete="off"
                        required={true}
                        name="percentage"
                        suffix=" %"
                        disabled={false}
                        decimalScale={2}
                        onValueChange={(vals) => handleChange("percentage", vals.value)}
                        value={values?.percentage}
                    />
                    </span>
                  </div>
                  <div className="text-align-left">
                    {formSubmitted && !values?.percentage && (
                      <small className="p-error">Please enter percentage</small>
                    )}
                  </div>
                </div>
              </div>
        

              {/* Start Date */}
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-4">Depletion Start Date</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field mt-1">
                  <div className="p-inputgroup">
                    <div className="p-inputgroup">
                    <Calendar
                      id="buttondisplay"
                      onChange={(date) =>
                        setValues({
                          ...values,
                          startDate: new Date(
                            Date.UTC(
                              date.value.getFullYear(),
                              date.value.getMonth(),
                              date.value.getDate()
                            )
                          )
                            .toISOString()
                            .split("T")[0],
                        })
                      }
                      value={
                        values?.startDate ? new Date(formatDate(values?.startDate)) : ""
                      }
                      showIcon
                      dateFormat="mm/dd/yy"
                    />
                    </div>
                     
                  </div>
                  <div className="text-align-left">
                      {formSubmitted && !values?.startDate && (
                        <small className="p-error">Please enter depletion start date</small>
                      )}
                       {formSubmitted && values?.startDate < values?.purchaseDate && (
                        <small className="p-error">Please enter depletion start date after asset purchase date</small>
                      )}
                  </div>
                </div>
              </div>
             
              {/* Amount */}
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-5  ">Depletion Amount</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field mt-1" style={{width:"103%"}}>
                  <div className="p-inputgroup">
                    <InputNumber
                      className="vw-inputtext-with-border pl-0"
                      
                      autoComplete="off"
                      required={true}
                      name="amount"
                      value={values?.amount}
                      disabled={true}
                      prefix="$ "
                    />
                  </div>

                </div>
              </div>

              {/* Action*/}
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">Description</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <InputText
                      className="vw-inputtext-with-border"
                      autoComplete="off"
                      required={true}
                      name="action"
                      value={values?.action}
                      onChange={handleInputChange}
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
          </form>
        </div>
      </div>
    </Dialog>
  );
};
export default AddDepletion;
